import { useAtomValue } from 'jotai';

import { userIdAtom } from '@/services/globalState';
import { shouldFetchUserScoped } from '@/util/authTokens';

/**
 * The account the app is acting as, for code whose data belongs to a user.
 *
 * `userId` is the impersonated support account while acting as one, otherwise
 * the signed-in user, and a Cognito UUID while an OAuth sign-up is pending.
 * `canFetch` says whether that id may ask the API for user-scoped data.
 *
 * Features read identity here, never from the atoms: a lint rule keeps Jotai
 * out of `features/`, so the atoms can move to another store without touching
 * them. Whether sign-in has settled at all is `useAuthResolved`.
 */
export function useUserScope() {
  const userId = useAtomValue(userIdAtom);

  return { userId, canFetch: shouldFetchUserScoped(userId) };
}
